import { PaymentRequisiteToType } from '@/entities/paymentRequisit'
import { IconStatus } from '@/shared/utils'
import {
  AMobileWithdrawMethodTypeTo,
  BankConfig,
  BankType,
  RequisitType,
  WithdrawStatus,
} from './types'
import { OptionModel } from '@/shared/lib/types'
import { AllBanksTypes, AllMethodsTypes } from 'syncra-storybook/shared/utils'

export type WithdrawButtonStatus =
  | 'completed'
  | 'paidPartially'
  | 'waitingProcessing'
  | 'canceled'
  | 'inProgress'
  | 'paymentInProgress'

export const WithdrawStatusTitles: Record<WithdrawStatus, string> = {
  [WithdrawStatus.Paid]: 'Выполненная заявка',
  [WithdrawStatus.PaidPartially]: 'Оплачена частично',
  [WithdrawStatus.WaitingProcessing]: 'Заявка в ожидании',
  [WithdrawStatus.Failed]: 'Отмененная заявка',
  [WithdrawStatus.InProgress]: 'Заявка в работе',
  [WithdrawStatus.PayingRightNow]: 'Заявка в работе',
}

export const WithdrawStatusIcons: Record<WithdrawStatus, IconStatus> = {
  [WithdrawStatus.Paid]: 'green',
  [WithdrawStatus.PaidPartially]: 'green',
  [WithdrawStatus.WaitingProcessing]: 'yellow',
  [WithdrawStatus.Failed]: 'red',
  [WithdrawStatus.InProgress]: 'purple',
  [WithdrawStatus.PayingRightNow]: 'purple',
}

export const WithdrawStatusButtons: Record<WithdrawStatus, WithdrawButtonStatus> = {
  [WithdrawStatus.Paid]: 'completed',
  [WithdrawStatus.PaidPartially]: 'paidPartially',
  [WithdrawStatus.WaitingProcessing]: 'waitingProcessing',
  [WithdrawStatus.Failed]: 'canceled',
  [WithdrawStatus.InProgress]: 'inProgress',
  [WithdrawStatus.PayingRightNow]: 'inProgress',
}

export const AMobileWithdrawMethodNames: Record<AMobileWithdrawMethodTypeTo, string> = {
  [AMobileWithdrawMethodTypeTo.SberByCard]: 'Сбер (карта)',
  [AMobileWithdrawMethodTypeTo.SberByPhone]: 'Сбер (телефон)',
  [AMobileWithdrawMethodTypeTo.TBankByCard]: 'Т-Банк (карта)',
  [AMobileWithdrawMethodTypeTo.Unknown]: 'Неизвестно',
  [AMobileWithdrawMethodTypeTo.UnknownCard]: 'Карта',
  [AMobileWithdrawMethodTypeTo.UnknownSbp]: 'СБП',
}

export const BANK_CONFIG: Record<BankType, BankConfig> = {
  [BankType.TBank]: {
    name: 'Т-Банк',
    availableTypes: [RequisitType.Card],
    methodMapping: {
      [RequisitType.Card]: AMobileWithdrawMethodTypeTo.TBankByCard,
      [RequisitType.Phone]: AMobileWithdrawMethodTypeTo.Unknown, // Fallback
    },
  },
  [BankType.Sber]: {
    name: 'Сбер',
    availableTypes: [RequisitType.Phone, RequisitType.Card],
    methodMapping: {
      [RequisitType.Phone]: AMobileWithdrawMethodTypeTo.SberByPhone,
      [RequisitType.Card]: AMobileWithdrawMethodTypeTo.SberByCard,
    },
  },
  // [BankType.Any]: {
  //   name: 'Любой банк',
  //   availableTypes: [RequisitType.Card],
  //   methodMapping: {
  //     [RequisitType.Card]: AMobileWithdrawMethodTypeTo.UnknownCard,
  //     [RequisitType.Phone]: AMobileWithdrawMethodTypeTo.Unknown, // Fallback
  //   },
  // },
}
// Маппинг BankType в TraderBankType
export const bankTypeToTraderBankMapping: Record<BankType, AllBanksTypes> = {
  [BankType.TBank]: AllBanksTypes.TBank,
  [BankType.Sber]: AllBanksTypes.Sber,
}

// Маппинг RequisitType в TraderMethodType
export const requisitTypeToTraderMethodMapping: Record<RequisitType, AllMethodsTypes> = {
  [RequisitType.Card]: AllMethodsTypes.Card,
  [RequisitType.Phone]: AllMethodsTypes.Sbp,
}
//withdraw
export const AMobileWithdrawMethodBanks: Record<AMobileWithdrawMethodTypeTo, string> = {
  [AMobileWithdrawMethodTypeTo.SberByCard]: 'Сбербанк',
  [AMobileWithdrawMethodTypeTo.SberByPhone]: 'Сбербанк',
  [AMobileWithdrawMethodTypeTo.TBankByCard]: 'Т-Банк (Тинькофф)',
  [AMobileWithdrawMethodTypeTo.Unknown]: 'Неизвестно',
  [AMobileWithdrawMethodTypeTo.UnknownCard]: 'Карта',
  [AMobileWithdrawMethodTypeTo.UnknownSbp]: 'СБП',
}

export const AMobileWithdrawMethods: Record<AMobileWithdrawMethodTypeTo, string> = {
  [AMobileWithdrawMethodTypeTo.SberByCard]: 'Карта',
  [AMobileWithdrawMethodTypeTo.SberByPhone]: 'Телефон',
  [AMobileWithdrawMethodTypeTo.TBankByCard]: 'Карта',
  [AMobileWithdrawMethodTypeTo.Unknown]: 'Неизвестно',
  [AMobileWithdrawMethodTypeTo.UnknownCard]: 'Карта',
  [AMobileWithdrawMethodTypeTo.UnknownSbp]: 'СБП',
}

export const withdrawMethodsType: Record<AMobileWithdrawMethodTypeTo, PaymentRequisiteToType> = {
  [AMobileWithdrawMethodTypeTo.SberByCard]: PaymentRequisiteToType.CardNumber,
  [AMobileWithdrawMethodTypeTo.SberByPhone]: PaymentRequisiteToType.SbpPhoneNumber,
  [AMobileWithdrawMethodTypeTo.TBankByCard]: PaymentRequisiteToType.CardNumber,
  [AMobileWithdrawMethodTypeTo.Unknown]: PaymentRequisiteToType.AccountNumber,
  [AMobileWithdrawMethodTypeTo.UnknownCard]: PaymentRequisiteToType.CardNumber,
  [AMobileWithdrawMethodTypeTo.UnknownSbp]: PaymentRequisiteToType.SbpPhoneNumber,
}

export const withdrawStatusOptions: OptionModel[] = [
  { label: 'Все', value: '', index: 0 },
  {
    label: WithdrawStatusTitles[WithdrawStatus.WaitingProcessing],
    value: WithdrawStatus.WaitingProcessing,
    index: 1,
  },
  {
    label: WithdrawStatusTitles[WithdrawStatus.Paid],
    value: WithdrawStatus.Paid,
    index: 2,
  },
  {
    label: WithdrawStatusTitles[WithdrawStatus.PaidPartially],
    value: WithdrawStatus.PaidPartially,
    index: 3,
  },
  {
    label: WithdrawStatusTitles[WithdrawStatus.Failed],
    value: WithdrawStatus.Failed,
    index: 4,
  },
  {
    label: WithdrawStatusTitles[WithdrawStatus.InProgress],
    value: WithdrawStatus.InProgress,
    index: 5,
  },
  {
    label: WithdrawStatusTitles[WithdrawStatus.PayingRightNow],
    value: WithdrawStatus.PayingRightNow,
    index: 6,
  },
]
